import api from "../services/api"

const searchGifs = async ({ q = "", provider = "tenor", limit = 24, cursor } = {}) => {
    const response = await api.get("/chat/gifs/search", {
        params: {
            q,
            provider,
            limit,
            pos: provider === "tenor" ? cursor : undefined,
            offset: provider === "giphy" ? cursor : undefined,
        }
    })
    return response.data?.data
}

const prepareGif = async ({ url, title }) => {
    const response = await api.post("/chat/gifs/prepare", { url, title })
    return response.data?.data
}

const getStickerFavorites = async () => {
    const response = await api.get("/chat/stickers/favorites")
    return response.data?.data || []
}

const favoriteSticker = async (content) => {
    const response = await api.post("/chat/stickers/favorites", { content })
    return response.data?.data
}

const deleteStickerFavorite = async (favorite_id) => {
    const response = await api.delete(`/chat/stickers/favorites/${favorite_id}`)
    return response.data
}

export { searchGifs, prepareGif, getStickerFavorites, favoriteSticker, deleteStickerFavorite }
